export default function forms() {

    const forms = document.querySelectorAll('.js-form');

    if (forms.length > 0) {
        forms.forEach(form => {
            form.addEventListener('submit', (e) => {
                e.preventDefault();

                let formData = new FormData(form);
                let formAction = form.getAttribute("action");
                fetch(formAction, {
                    method: "POST",
                    body: formData
                }).then(response => response.json()).then(response => {
                    if (response.success) {

                        form.reset();
                        
                        openModal('success');
                        
                    } else {
                        
                        openModal('failure');

                    }
                });

            });
        });
    }
}